import React, { createContext, useContext, useState } from "react";

import { CommandBar, ProgressIndicator,Persona,PersonaSize } from "@fluentui/react";
import { Button, Empty, Space,Skeleton,notification } from "antd";
import { SubPageHeaderTitle } from "../../../shared/SubPageHeaderTitle";
import HighlightStore from "./store/highlightstore";
import { observer } from "mobx-react-lite";
import ReactQuill from "react-quill";
import moment from "moment";
import {
  getCurrentUser,
  reactQuiltoolbarOptions,
} from "../../../Utility/modules/helpers";
import _ from "underscore";
import { SaveFilled } from "@ant-design/icons";
import MainStore from "../../home/store/mainStore";
import renderHTML from "react-render-html";
const HighlightStoreCtx = createContext(HighlightStore);
const MainStoreCtx = createContext(MainStore);
export const Highlight = observer((props) => {
  const highlightStore = useContext(HighlightStoreCtx);
  const [openEdit, setOpenEdit] = useState(false);
  const mainStore = useContext(MainStoreCtx);
  return (
    <div className="ms-Grid" dir="ltr">
      <div className="ms-Grid-row" style={{ display: "flex", padding: "5px" }}>
        <div className="ms-Grid-col ms-sm5">
          <SubPageHeaderTitle
            title={`${mainStore.assetContextName} JV Week Highlights/Sucesses`}
            color={props.color}
          />
        </div>
        <div className="ms-Grid-col ms-sm7">
          <CommandBar
            farItems={[
              {
                key: "add1",
                onRender: () => (
                  <Button
                    type={props.type === "highlight" ? "primary" : "danger"}
                    onClick={() => {
                      highlightStore.highlightType =
                        props.type === "highlight" ? "high" : "low";
                      setOpenEdit(true);
                    }}
                  >
                  {_.isEmpty( highlightStore.highlightDescription)?"Add":"Edit"}
                    {props.type === "highlight" ? " Highlights" : " Lowlights"}
                  </Button>
                ),
              },
            ]}
          />
        </div>
      </div>
      {openEdit && (
        <>
          <div className="ms-Grid-row" style={{ height: "40vh" }}>
            <div className="ms-Grid-col ms-sm12" style={{ height: "40vh" }}>
              <ReactQuill
                modules={{ toolbar: reactQuiltoolbarOptions }}
                onChange={(value) => {
                  if (props.type === "highlight") {
                    highlightStore.highlightDescription = value;
                  } else {
                    highlightStore.lowlightDescription = value;
                  }
                }}
                value={
                  props.type === "highlight"
                    ? highlightStore.highlightDescription
                    : highlightStore.lowlightDescription
                }
                style={{ height: "30vh" }}
                placeholder={`Enter ${
                  props.type === "highlight"
                    ? "Production highlights/successes"
                    : "Production lowlights/limitations"
                } here`}
              />
            </div>
          </div>
          <div className="ms-Grid-row">
            {
              <div className="ms-Grid-col ms-sm6">
                {highlightStore.isSaving && (
                  <ProgressIndicator
                    description={`saving ${
                      props.type === "highlight"
                        ? "please wait,saving production highlights/successes"
                        : "please wait,saving production lowlights/limitations"
                    }...`}
                    styles={{ root: { textAlign: "center" } }}
                  ></ProgressIndicator>
                )}
              </div>
            }
            <div
              className="ms-Grid-col ms-sm6"
              style={{ display: "flex", justifyContent: "right" }}
            >
              <Space>
                <Button
                  onClick={() => {
                    setOpenEdit(false);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  icon={<SaveFilled />}
                  type="primary"
                  onClick={async () => {
                    try {
                      highlightStore.highlightType = props.type;
                      let highlight = {...highlightStore.highlight,
                        assetId: mainStore.assetContextId,
                        productionYear: highlightStore.prodYear,
                        productionMonth: highlightStore.selectedMonth,
                        productionWeek: highlightStore.selectedWeek,
                        weekName: highlightStore.selectedWeekName,
                        highlightDescription:
                          highlightStore.highlightDescription,
                        lowlightDescription: highlightStore.lowlightDescription,
                        uploadedBy: getCurrentUser()?.fullName,
                      };
                      await highlightStore.save(highlight);
                        notification.success({
            message: "SPARS Feedback",
            description: `${
                      props.type === "highlight"
                        ? "highlights"
                        : "lowlights"
                    } saved successfully`,
          });
          setOpenEdit(false)
                    } catch (error) {
notification.error({
            message: "SPARS Feedback",
            description: error.response && error.response.text,
          });

                    }
                  }}
                >
                  Save
                </Button>
              </Space>
            </div>
          </div>
        </>
      )}
{highlightStore.isLoading && (<><Skeleton active/>
<Skeleton active/>
<Skeleton active/>
</>)}
      {!openEdit && (
        <div className="ms-Grid-row">
          <div
            className="ms-Grid-col ms-sm12 "
            style={{
             margin:'10px',
              padding: "10px",
              minHeight: "50vh",
              
            }}
          >
           {_.isEmpty( highlightStore.highlightDescription) ?
              (<Empty description={props.emptyText} style={{marginTop:'200px'}} />):props.type === "highlight"?(
                <>{renderHTML(highlightStore.highlightDescription)}
                <div className='ms-Grid-col ms-sm12' style={{display:'flex',justifyContent:'right'}}>  <Persona size={PersonaSize.size40} text={highlightStore.highlight.uploadedBy} secondaryText={moment(highlightStore.highlight.uploadedOn).fromNow()}/></div>
              
                </>
                ):(<>{renderHTML(highlightStore.lowlightDescription)}
                 <div className='ms-Grid-col ms-sm12' style={{display:'flex',justifyContent:'right'}}>  <Persona size={PersonaSize.size40} text={highlightStore.highlight.uploadedBy} secondaryText={moment(highlightStore.highlight.uploadedOn).fromNow()}/></div>
                </>)
              }
          </div>
        </div>
      )}
    </div>
  );
});

